export default __webpack_public_path__ + "static/media/icon-cancel.a4f34eb9.svg";